var _rect, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.326447,
    y: 5.0918,
    width: 3.22792,
    height: 10.0171,
    fill: "#003A9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3419 5.20927C12.3076 5.19834 12.2751 5.1865 12.239 5.17649C12.1957 5.16647 12.1524 5.15827 12.1082 5.15099C11.9368 5.11638 11.7491 5.0918 11.529 5.0918C9.64711 5.0918 8.45356 6.47325 8.06022 7.00689V5.0918H4.83231V15.1089H8.06022V9.64503C8.06022 9.64503 10.4997 6.21554 11.529 8.73439C11.529 10.9828 11.529 15.1089 11.529 15.1089H14.756V8.34918C14.756 6.83569 13.7285 5.57444 12.3419 5.20927Z",
    fill: "#003A9B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.90522,
    cy: 2.1327,
    rx: 1.57877,
    ry: 1.59363,
    fill: "#003A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ea588873ce6c05a026ec422b9790a18f.svg";
export { ForwardRef as ReactComponent };